import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';

const { FiStar, FiChevronLeft, FiChevronRight } = FiIcons;

const testimonials = [
  {
    name: 'Sarah M.',
    location: 'New York, USA',
    rating: 5,
    text: 'I finally understand why my husband shuts down during arguments. This book didn\'t just help our marriage — it saved it. I wish I had read it years ago.',
    avatar: 'SM',
  },
  {
    name: 'Elena R.',
    location: 'London, UK',
    rating: 5,
    text: 'Andrei writes with such empathy and clarity. The chapter on "The Language of Action" completely reframed how I see my partner. Extraordinary book.',
    avatar: 'ER',
  },
  {
    name: 'Christine L.',
    location: 'Toronto, Canada',
    rating: 5,
    text: 'I was skeptical of relationship books, but this one is different. It\'s practical, honest, and deeply compassionate. I\'ve already gifted it to three friends.',
    avatar: 'CL',
  },
  {
    name: 'Maria T.',
    location: 'Sydney, Australia',
    rating: 5,
    text: 'Reading this felt like someone finally gave me the manual I\'d been searching for. The insights are profound yet accessible. A must-read for any woman.',
    avatar: 'MT',
  },
];

const TestimonialsStrip = () => {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((c) => (c - 1 + testimonials.length) % testimonials.length);
  const next = () => setCurrent((c) => (c + 1) % testimonials.length);

  return (
    <section className="py-24 bg-amber-50 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-amber-50 via-orange-50/30 to-amber-50 pointer-events-none" />
      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center">
        <span className="text-brand-accent font-semibold tracking-widest uppercase text-xs">Reader Stories</span>
        <h3 className="text-4xl font-serif font-bold text-brand-dark mt-3 mb-12">Lives Changed, Relationships Transformed</h3>

        <div className="relative">
          <AnimatePresence mode="wait">
            <motion.div
              key={current}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.4 }}
              className="bg-white rounded-3xl p-10 shadow-xl shadow-slate-200/60"
            >
              <div className="flex justify-center mb-4">
                {[...Array(testimonials[current].rating)].map((_, i) => (
                  <FiStar key={i} className="text-amber-400 fill-amber-400" size={20} />
                ))}
              </div>
              <p className="text-xl md:text-2xl font-serif text-slate-700 leading-relaxed mb-8 italic">
                "{testimonials[current].text}"
              </p>
              <div className="flex items-center justify-center gap-3">
                <div className="w-10 h-10 bg-brand-accent text-white rounded-full flex items-center justify-center font-bold text-sm">
                  {testimonials[current].avatar}
                </div>
                <div className="text-left">
                  <div className="font-semibold text-brand-dark">{testimonials[current].name}</div>
                  <div className="text-sm text-slate-400">{testimonials[current].location}</div>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>

          <div className="flex justify-center gap-4 mt-8">
            <button onClick={prev} className="w-10 h-10 bg-white border border-slate-200 rounded-full flex items-center justify-center hover:bg-brand-dark hover:text-white hover:border-brand-dark transition-colors">
              <FiChevronLeft size={18} />
            </button>
            {testimonials.map((_, i) => (
              <button key={i} onClick={() => setCurrent(i)} className={`w-2.5 h-2.5 rounded-full transition-colors mt-3.5 ${i === current ? 'bg-brand-accent' : 'bg-slate-300'}`} />
            ))}
            <button onClick={next} className="w-10 h-10 bg-white border border-slate-200 rounded-full flex items-center justify-center hover:bg-brand-dark hover:text-white hover:border-brand-dark transition-colors">
              <FiChevronRight size={18} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsStrip;